export type CoinProps = {
  id: number;
  name: string;
  symbol: string;
  websiteSlug: string;
  rank: number;
  circulatingSupply: number;
  totalSupply: number;
  maxSupply: number | null;
  quotes: {
    usd: {
      price: number;
      volume24h: number;
      marketCap: number;
      percentChange1h: number;
      percentChange24h: number;
      percentChange7d: number;
    };
    btc: {
      price: number;
      volume24h: number;
      marketCap: number;
      percentChange1h: number;
      percentChange24h: number;
      percentChange7d: number;
    };
  };
  lastUpdated: number;
};

type CoinListProps = {
  [key: number]: CoinProps;
};

const coinPrices: CoinListProps = {
  1925: {
    id: 1925,
    name: 'Waltonchain',
    symbol: 'WTC',
    websiteSlug: 'waltonchain',
    rank: 45,
    circulatingSupply: 40144099.0,
    totalSupply: 70000000.0,
    maxSupply: 100000000.0,
    quotes: {
      usd: {
        price: 4.7030847533,
        volume24h: 26472420.3341336,
        marketCap: 188801102.0,
        percentChange1h: 0.79,
        percentChange24h: 7.28,
        percentChange7d: 50.54,
      },
      btc: {
        price: 0.0006780206,
        volume24h: 3813.163070469,
        marketCap: 27219.0,
        percentChange1h: -0.78,
        percentChange24h: 5.04,
        percentChange7d: 43.1,
      },
    },
    lastUpdated: 1535735967,
  },
  2896: {
    id: 2896,
    name: 'Mainframe',
    symbol: 'MFT',
    websiteSlug: 'mainframe',
    rank: 207,
    circulatingSupply: 2542862213.0,
    totalSupply: 10000000000.0,
    maxSupply: null,
    quotes: {
      usd: {
        price: 0.0087036908,
        volume24h: 4845766.81872573,
        marketCap: 22132286.0,
        percentChange1h: 1.79,
        percentChange24h: 17.15,
        percentChange7d: 50.67,
      },
      btc: {
        price: 0.0000012764,
        volume24h: 722.6142620213,
        marketCap: 3246.0,
        percentChange1h: 3.03,
        percentChange24h: 19.57,
        percentChange7d: 46.18,
      },
    },
    lastUpdated: 1535736101,
  },
  1376: {
    id: 1376,
    name: 'NEO',
    symbol: 'NEO',
    websiteSlug: 'neo',
    rank: 15,
    circulatingSupply: 65000000.0,
    totalSupply: 100000000.0,
    maxSupply: 100000000.0,
    quotes: {
      usd: {
        price: 19.5535223306,
        volume24h: 60605594.5534892,
        marketCap: 1270978951.0,
        percentChange1h: 0.32,
        percentChange24h: 2.91,
        percentChange7d: 10.84,
      },
      btc: {
        price: 0.0028554393,
        volume24h: 9149.511382894,
        marketCap: 185604.0,
        percentChange1h: 1.01,
        percentChange24h: 3.96,
        percentChange7d: 6.94,
      },
    },
    lastUpdated: 1535736086,
  },
  1765: {
    id: 1765,
    name: 'EOS',
    symbol: 'EOS',
    websiteSlug: 'eos',
    rank: 5,
    circulatingSupply: 906245118.0,
    totalSupply: 1006245120.0,
    maxSupply: null,
    quotes: {
      usd: {
        price: 6.3491925824,
        volume24h: 855600553.041719,
        marketCap: 5753924779.0,
        percentChange1h: 1.73,
        percentChange24h: 6.59,
        percentChange7d: 28.1,
      },
      btc: {
        price: 0.0009010785,
        volume24h: 128112.2118684887,
        marketCap: 816598.0,
        percentChange1h: -1.25,
        percentChange24h: 4.28,
        percentChange7d: 20.03,
      },
    },
    lastUpdated: 1535736149,
  },
  2243: {
    id: 2243,
    name: 'Dragonchain',
    symbol: 'DRGN',
    websiteSlug: 'dragonchain',
    rank: 119,
    circulatingSupply: 238421940.0,
    totalSupply: 433494437.0,
    maxSupply: null,
    quotes: {
      usd: {
        price: 0.1993993329,
        volume24h: 768972.352133687,
        marketCap: 47541176.0,
        percentChange1h: -0.02,
        percentChange24h: 4.46,
        percentChange7d: 5.63,
      },
      btc: {
        price: 0.0000284205,
        volume24h: 108.3113236084,
        marketCap: 6776.0,
        percentChange1h: -0.51,
        percentChange24h: 2.63,
        percentChange7d: -1.4,
      },
    },
    lastUpdated: 1535736156,
  },
  2578: {
    id: 2578,
    name: 'TE-FOOD',
    symbol: 'TFD',
    websiteSlug: 'te-food',
    rank: 403,
    circulatingSupply: 497598188.0,
    totalSupply: 567917833.0,
    maxSupply: 1000000000.0,
    quotes: {
      usd: {
        price: 0.0151385646,
        volume24h: 45183.3266169752,
        marketCap: 7532922.0,
        percentChange1h: 0.01,
        percentChange24h: -1.4,
        percentChange7d: 21.16,
      },
      btc: {
        price: 0.0000022507,
        volume24h: 6.130820075,
        marketCap: 1120.0,
        percentChange1h: 3.24,
        percentChange24h: 1.03,
        percentChange7d: 18.96,
      },
    },
    lastUpdated: 1535736216,
  },
  2861: {
    id: 2861,
    name: 'GoChain',
    symbol: 'GO',
    websiteSlug: 'gochain',
    rank: 154,
    circulatingSupply: 504385123.0,
    totalSupply: 1013022590.0,
    maxSupply: null,
    quotes: {
      usd: {
        price: 0.0629683891,
        volume24h: 3129426.94017412,
        marketCap: 31760319.0,
        percentChange1h: -0.54,
        percentChange24h: 10.52,
        percentChange7d: 110.97,
      },
      btc: {
        price: 0.0000088288,
        volume24h: 459.4797629165,
        marketCap: 4453.0,
        percentChange1h: -2.61,
        percentChange24h: 6.49,
        percentChange7d: 95.3,
      },
    },
    lastUpdated: 1535736286,
  },
  2840: {
    id: 2840,
    name: 'QuarkChain',
    symbol: 'QKC',
    websiteSlug: 'quarkchain',
    rank: 166,
    circulatingSupply: 748316585.0,
    totalSupply: 10000000000.0,
    maxSupply: null,
    quotes: {
      usd: {
        price: 0.0375463188,
        volume24h: 5722880.08709168,
        marketCap: 28096533.0,
        percentChange1h: 0.4,
        percentChange24h: 10.49,
        percentChange7d: 41.67,
      },
      btc: {
        price: 0.0000053723,
        volume24h: 815.2633990891,
        marketCap: 4020.0,
        percentChange1h: -0.19,
        percentChange24h: 9.05,
        percentChange7d: 33.38,
      },
    },
    lastUpdated: 1535736281,
  },
  2398: {
    id: 2398,
    name: 'Selfkey',
    symbol: 'KEY',
    websiteSlug: 'selfkey',
    rank: 238,
    circulatingSupply: 2430991491.0,
    totalSupply: 5999999954.0,
    maxSupply: null,
    quotes: {
      usd: {
        price: 0.0073443689,
        volume24h: 3801858.03816362,
        marketCap: 17854098.0,
        percentChange1h: 1.96,
        percentChange24h: 9.48,
        percentChange7d: 26.66,
      },
      btc: {
        price: 0.0000010609,
        volume24h: 573.6082472582,
        marketCap: 2579.0,
        percentChange1h: 0.45,
        percentChange24h: 9.47,
        percentChange7d: 20.75,
      },
    },
    lastUpdated: 1535736275,
  },
};

export default coinPrices;



// WEBPACK FOOTER //
// ./src/data/coinPrices.tsx